import { IMember } from '../schemas/entity_set';
import { PartialViews, Routes } from '../helpers/config_keys';
import { IMemberService } from './member_service';
import { MessageBox } from '../helpers/message_box';
import { ITransactionService, ITransactionFilter } from '../transactions/transaction_service';
import { IReportService } from "../reports/report_service";

class MemberAccountCtrl {
    member: IMember;
    loading: boolean;

    static $inject = ["$state", "$stateParams", "MemberService", "TransactionService", "ReportService"];
    constructor(private $state: angular.ui.IStateService,
        private $stateParams: angular.ui.IStateParamsService,
        private memberService: IMemberService,
        private transactionService: ITransactionService,
        private reportService: IReportService) {
        this.start()
    }

    printStatement() {
        this.memberService.accountStatement(this.member.id).then((res) => {            
            if (res.success) this.reportService.openViewer(res.data)
        })
    }

    reloadTransactions(filter: ITransactionFilter) {
        filter.memberId = this.member.id
        filter.pager = filter.pager || { page: 1, size: 100 }
        this.transactionService.query(filter).then((res) => {
            if (res.success) this.member.transactions = res.data
        })
    }

    closeAccount() {
        MessageBox.confirm("Close Account", `Are you sure you want to close account for ${this.member.name}?`).then((yes) => {
            if (yes) {
                this.memberService.closeAccount(this.member.id).then((res) => {
                    if (res.success) this.$state.reload()
                })
            }
        })
    }

    private fetchMember(id: number) {
        this.loading = true
        this.memberService.info(id).then((res) => {
            this.loading = false
            if (res.success) { this.member = angular.copy(res.data) }
        })
    }

    private start() {
        if (this.$stateParams['id']) {
            this.fetchMember(+this.$stateParams['id'])
        }
        else { this.$state.go(Routes.Members) }
    }
}

export { MemberAccountCtrl }


// WEBPACK FOOTER //
// ./app/members/member_account_ctrl.ts